import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../Css/Home.css";
import VTSeva from "../Assets/VTSevaLogo.jpeg";
import EricTableTennis from "../Assets/EricTableTennis.jpg";
import PingPongParkinson from "../Assets/PingPongParkinson-Logo.jpeg";
import NeuroPong from "../Assets/NeuroPongLogo.jpeg";
import NorthWestParkinson from "../Assets/NorthWestParkinsonLogo.jpeg";
import PaddlePalaceLogo from "../Assets/PaddlePalaceLogo.png";
import MomentsPhotos from "../Pages/MomentsPhotos";
import TimeForYouWellness from "../Assets/TimeForYouWellness.jpeg";
import HomeBanner from "../Assets/HomeBanner.jpeg";
import APDALogo from "../Assets/APDA.jpeg";
import WSPHALogo from "../Assets/WSPHALogo.jpeg";
import APHALogo from "../Assets/APHALogo.jpeg";
import SunriseSeniorLiving from "../Assets/SunriseSeniorLivingLogo.jpeg";
import SPTTCLogo from "../Assets/spttc_logo.jpeg";
import OurImpact2Date1 from "../Assets/OurImpact2Date-1.jpeg";
import OurImpact2Date2 from "../Assets/OurImpact2Date-2.jpeg";
import IlyaRozenblat from "../Assets/IlyaRozenblat.jpeg";
import WilbertRimper from "../Assets/WilbertRimper.jpeg";
import JohnDiPasquale from "../Assets/JohnDiPasquale.jpeg";
import Joe from "../Assets/Joe.jpeg";

const Home = () => {
  const partnerLogos = [
    {
      name: "American Parkinson Disease Association - Northwest Chapter",
      image: APDALogo,
      url: "https://www.apdaparkinson.org/community/northwest/resources-support/health-wellness-opportunities/washington-health-wellness-programs/",
      label: "American Parkinson Disease Association (APDA) Northwest Health & Wellness Program.",
    },
    {
      name: "Northwest Parkinson's Foundation",
      image: NorthWestParkinson,
      url: "https://www.nwpf.org",
      label: "Northwest Parkinson's Foundation — supporting the Parkinson's community across the Pacific Northwest.",
    },
    {
      name: "Ping Pong Parkinson",
      image: PingPongParkinson,
      url: "https://www.pingpongparkinson.org",
      label: "PingPongParkinson® — Washington Chapter , Supporting people with Parkinson’s through table tennis.",
    },
    {
      name: "Eric Table Tennis",
      image: EricTableTennis,
      url: "https://www.erictabletennis.com",
      label: "Premier table tennis academy in Redmond, WA — Home to 11 WA State champions and Olympic-roster athletes.",
    },
    {
      name: "Paddle Palace",
      image: PaddlePalaceLogo,
      url: "https://www.paddlepalace.com",
      label: "The #1 table tennis equipment supplier in North America — stocking everything for the table tennis player, from recreational to professional level.",
    },
    {
      name: "VT Seva",
      image: VTSeva,
      url: "https://www.vtsworld.org/branch/seattle",
      label: "VT Seva is a global non-profit organization powered by volunteerism and compassion.",
    },
    {
      name: "TimeForYouWellness",
      image: TimeForYouWellness,
      url: "https://www.timeforyouwellness.net",
      label: "Holistic health coaching specialized in Parkinson's Disease support.",
    },
    {
      name: "NeuroPong",
      image: NeuroPong,
      url: "https://neuropong.org/",
      label: "Table tennis for MS, Parkinson's & Dementia — supporting motor skills and well-being.",
    },
    // ── 3rd row ──────────────────────────────────────────────
    // Items 9+ wrap onto the third row of the 4-up grid, so Sunrise
    // sits in position 1 (under Paddle Palace) and SPTTC in position 2.
    {
      name: "Sunrise Senior Living",
      image: SunriseSeniorLiving,
      url: "https://www.sunriseseniorliving.com",
      label: "Sunrise Senior Living — providing personalized senior care and memory care services.",
    },
    {
      name: "Seattle Pacific Table Tennis Club (SPTTC)",
      image: SPTTCLogo,
      url: "https://spttc.org",
      label: "Seattle Pacific Table Tennis Club — Bellevue, WA, home of our biweekly Parkinson's neuro-wellness sessions.",
    },
  ];

  const testimonials = [
    {
      name: "Ilya Rozenblat",
      role: "Parkinson’s Para-Athlete & World Champion",
      quote: "Table tennis helps reaction time, improves walking, and supports smoother, more confident movement.",
      image: IlyaRozenblat,
    },
    {
      name: "Wilbert Rimper",
      role: "Parkinson’s Para-Athlete",
      quote: "We are family, special, and need support and encouragement with good intentions — and table tennis is like a natural vitamin you take to stay alive, enjoy life, help each other, and be thankful for. I treat every day like it’s going to possibly be my last day on earth, so I try to enjoy the fullest life.",
      image: WilbertRimper,
    },
    {
      name: "John DiPasquale",
      role: "Parkinson’s Para-Athlete",
      quote: "Table tennis boosts dopamine, improves my medication’s effectiveness, and gives me joy.",
      image: JohnDiPasquale,
    },
    {
      name: "Joe",
      role: "Participant",
      quote: "Joe was excited to play ping pong each Saturday, calling it the only exercise he wanted to do. After his passing, his wife shared how meaningful those sessions were and thanked the program for supporting PD patients.",
      image: Joe,
    },
  ];

  
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "SportsForEquity | Empowering Neuro Wellness And Health Equity Using Table Tennis";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="home-wrapper">
      <div className="home-hero">
        <img
          src={HomeBanner}
          alt="Sports for Equity — community moments through table tennis"
          className="home-hero-img"
        />
        <div className="home-hero-overlay">
          <h1 className="home-hero-title">
            Empowering neuro wellness and health equity using table tennis
          </h1>
          <p className="home-hero-subtitle">
            Powered by passionate International and National Athletes.
          </p>
        </div>
      </div>

      <div className="home-content">
        <div className="impact-section">

          {/* ── Why SportsForEquity Matters ── */}
          <div className="why-matters-section">
            <h2 className="why-matters-heading">Why SportsForEquity Matters</h2>
            <p className="why-matters-text">
              Neurological conditions affect more than 1 in 3 people worldwide, yet access to community wellness remains unequal.
            </p>
            <p className="why-matters-source">
              <strong>World Health Organization, 2024</strong>
            </p>
            <Link
              to="/research"
              className="why-matters-btn"
              onClick={() => window.scrollTo(0, 0)}
            >
              Explore More
            </Link>
          </div>
          <div className="programs-glance-box">
            <h3 className="programs-glance-heading">Programs — Schedule &amp; Registration</h3>
            <div className="programs-row">
              <Link
                to="/programs/ParkinsonSession"
                className="program-item program-item--link"
              >
                <div className="program-icon">🏓</div>
                <div className="program-title program-title--blue">Parkinson’s Neuro-Wellness Sessions</div>
              </Link>
              <Link
                to="/programs/CommunityOutreach"
                className="program-item program-item--link"
              >
                <div className="program-icon">🌐</div>
                <div className="program-title program-title--green">Community Outreach</div>
              </Link>
              <Link
                to="/programs/YouthEmpowerment"
                className="program-item program-item--link"
              >
                <div className="program-icon">🏅</div>
                <div className="program-title program-title--purple">Youth Athlete's Training</div>
              </Link>
              <Link
                to="/programs/HealthEquitySupport"
                className="program-item program-item--link"
              >
                <div className="program-icon">❤️</div>
                <div className="program-title program-title--red">Healthcare Support</div>
              </Link>              
            </div>
          </div>

          <div className="referral-network-box">
            <h3 className="referral-network-heading">TRUSTED REFERRAL NETWORK</h3>
            <p className="referral-network-text">
              SportsForEquity receives participant referrals from Physical Therapists, Parkinson's Specialists, Neurologists, and Parkinson's Community Organizations, helping connect people with accessible table-tennis neuro-wellness programs.
            </p>
            <div className="referral-network-grid">
              <div className="referral-network-card referral-network-card--pt">
                <span className="referral-network-icon">🦽</span>
                <span className="referral-network-label">Physical Therapists</span>
              </div>
              <div className="referral-network-card referral-network-card--ps">
                <span className="referral-network-icon">🧠</span>
                <span className="referral-network-label">Parkinson's Specialists</span>
              </div>
              <div className="referral-network-card referral-network-card--neuro">
                <span className="referral-network-icon">🔬</span>
                <span className="referral-network-label">Neurologists</span>
              </div>
              <div className="referral-network-card referral-network-card--org">
                <span className="referral-network-icon">🤝</span>
                <span className="referral-network-label">Parkinson's Organizations</span>
              </div>
            </div>
          </div>

          <div className="un-goals-box">
            <h3 className="un-goals-heading">PUBLIC-HEALTH RECOGNITION</h3>
            <div className="recognition-grid">
              <div className="recognition-card recognition-card--full">
                <div className="recognition-logo-grid">
                  <a
                    href="https://wspha.org/"
                    target="_blank"
                    rel="noreferrer"
                    title="Washington State Public Health Association"
                    className="recognition-logo-card"
                  >
                    <img
                      src={WSPHALogo}
                      alt="Washington State Public Health Association logo"
                      className="recognition-logo-img"
                    />
                  </a>
                  <a
                    href="https://www.apha.org/"
                    target="_blank"
                    rel="noreferrer"
                    title="American Public Health Association"
                    className="recognition-logo-card"
                  >
                    <img
                      src={APHALogo}
                      alt="American Public Health Association logo"
                      className="recognition-logo-img"
                    />
                  </a>
                  <a
                    href="https://nwpf.org/"
                    target="_blank"
                    rel="noreferrer"
                    title="Northwest Parkinson's Foundation"
                    className="recognition-logo-card"
                  >
                    <img
                      src={NorthWestParkinson}
                      alt="Northwest Parkinson's Foundation logo"
                      className="recognition-logo-img"
                    />
                  </a>
                  <a
                    href="https://www.apdaparkinson.org/community/northwest/resources-support/health-wellness-opportunities/washington-health-wellness-programs/"
                    target="_blank"
                    rel="noreferrer"
                    title="American Parkinson Disease Association - Northwest Chapter"
                    className="recognition-logo-card"
                  >
                    <img
                      src={APDALogo}
                      alt="American Parkinson Disease Association (APDA) Northwest logo"
                      className="recognition-logo-img"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="our-impact-section">
            <h3 className="our-impact-heading">Our Last quarter Impact</h3>
            <p className="our-impact-subheading">              
              Every table-tennis ball, every smile, and every breakthrough reminds us why this work matters. Through neuro-wellness programs, health-equity support, and the leadership of empowered young athletes, we’re building a community where movement restores hope — and everyone feels seen, supported, and connected.
            </p>
            <div className="our-impact-images">
              <div className="our-impact-image-wrapper">
                <img
                  src={OurImpact2Date1}
                  alt="Sports For Equity impact overview"
                  className="our-impact-image"
                />
              </div>
              <div className="our-impact-image-wrapper">
                <img
                  src={OurImpact2Date2}
                  alt="Sports For Equity impact cards"
                  className="our-impact-image"
                />
              </div>
            </div>
          </div>

          <div className="partners-section">
            <h3 className="partners-heading">Community Partners & Supporters</h3>
            <p className="partners-subheading">
              Interested in our mission to transform lives through table tennis?
              Please contact us at{" "}
              <a
                href="mailto:info@sportsforequity.live"
                style={{ color: "#22D3EE", textDecoration: "none" }}
              >
                info@sportsforequity.live
              </a>
            </p>
            {/* One grid for every logo: the 4-up track wraps on its own, so
                the 3rd row starts in column 1 (under Paddle Palace) instead
                of floating centred as a separate grid. */}
            <div className="partners-grid">
              {partnerLogos.filter(p => !p.spacer).map((partner, index) => (
                  <div key={index} className="partner-card-wrapper">
                    <a
                      href={partner.url}
                      className="partner-card"
                      target="_blank"
                      rel="noreferrer"
                      title={partner.name}
                    >
                      <img
                        src={partner.image}
                        alt={partner.name}
                        className="partner-image"
                      />
                    </a>
                  </div>
              ))}
            </div>
          </div>

          {MomentsPhotos.length > 0 && (
            <div className="moments-section">
              <h3 className="moments-heading">Moments of Impact</h3>
              <p className="moments-subheading">
                Capturing the heart of our community in action.
              </p>
              <div className="moments-gallery">
                {MomentsPhotos.map((item, index) => (
                  <div className="moments-image-wrapper" key={index}>
                    <img
                      src={item.img}
                      alt={item.alt}
                      className="moments-image"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="testimonials-section">
            <h3 className="testimonials-heading">
              Voices From Our Community
            </h3>
            <div className="testimonials-grid">
              {testimonials.map((item, index) => (
                <div className="testimonial-card" key={index}>
                  <img
                    src={item.image}
                    alt={item.name}
                    className="testimonial-photo"
                  />
                  <p className="testimonial-quote">&#8220;{item.quote}&#8221;</p>
                  <div className="testimonial-name">{item.name}</div>
                  <div className="testimonial-role">{item.role}</div>
                </div>
              ))}
            </div>
            <div className="testimonials-cta">
              <Link
                to="/impact-stories"
                className="testimonials-cta-btn"
                onClick={() => window.scrollTo(0, 0)}
              >
                View More Stories
              </Link>
            </div>
          </div>

          <div className="impact-glance-box">
            <h3 className="impact-glance-heading">Impact at a Glance — To Date</h3>
            <div className="metrics-row">
              <div className="metric-item">
                <div className="metric-number metric-blue">167</div>
                <div className="metric-title">Parkinson’s Neuro-Wellness Sessions</div>
              </div>
              <div className="metric-item">
                <div className="metric-number metric-red">21</div>
                <div className="metric-title">National Athlete Leaders</div>
              </div>
              <div className="metric-item">
                <div className="metric-number metric-purple">55</div>
                <div className="metric-title">Young Athletes Empowered</div>
              </div>
              <div className="metric-item">
                <div className="metric-number metric-green">10</div>
                <div className="metric-title">National Chapters</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;